"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isWeekday = exports.setMinDate = exports.excludeLast24orOverOfficeHour = void 0;
exports.initDate = initDate;
var moment = require("moment");
require("moment-timezone");
function initDate() {
    var currentDate = new Date();
    var helsinkiTime = moment(currentDate).tz('Europe/Helsinki');
    // check if friday
    if (moment(currentDate).day() === 5) {
        if (helsinkiTime.hours() <= 11 && helsinkiTime.hours() >= 0) {
            return moment()
                .weeks(moment().weeks() + 1)
                .days(1)
                .hours(16)
                .minutes(0);
        }
        var b = moment()
            .weeks(moment().weeks() + 1)
            .days(2)
            .hours(13)
            .minutes(0);
        return b;
    }
    // check if thursday and time is over 12.00
    if (moment(currentDate).day() === 4 && helsinkiTime.hours() >= 12) {
        return moment()
            .weeks(moment().weeks() + 1)
            .days(1)
            .hours(13)
            .minutes(0);
    }
    // check if monday
    if (moment(currentDate).day() === 1) {
        // check if time between 00.01 and 12.00
        if (helsinkiTime.hours() <= 11 && helsinkiTime.hours() >= 0) {
            return moment().days(2).hours(16).minutes(0);
        }
        return moment().days(3).hours(13).minutes(0);
    }
    if (helsinkiTime.hours() > 17) {
        return helsinkiTime.set('date', helsinkiTime.date() + 2);
    }
    return helsinkiTime
        .set('date', helsinkiTime.date() + 1)
        .set('hours', 16)
        .set('minutes', 0);
}
var excludeLast24orOverOfficeHour = function (requestTimeOfDelivery) {
    var selectedDate = new Date(requestTimeOfDelivery);
    var currentDate = new Date();
    var currHours = moment().hours();
    var currMins = moment().minutes();
    if (selectedDate.getDate() === currentDate.getDate()) {
        currHours++;
        return moment(selectedDate).hours(currHours).minutes(currMins);
    }
    return moment(selectedDate).hours(8).minutes(0);
};
exports.excludeLast24orOverOfficeHour = excludeLast24orOverOfficeHour;
var setMinDate = function () {
    var now = moment(new Date());
    if (now.hours() >= 15) {
        now.date(now.date() + 1);
        return now;
    }
    return moment(new Date());
};
exports.setMinDate = setMinDate;
var isWeekday = function (date) {
    var day = date.day();
    return day !== 0 && day !== 6;
};
exports.isWeekday = isWeekday;
